import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { Columns } from '@components/Columns';

export const StyledUniversalRegistry = styled(Box)<{
  backgroundImage: string;
  resHeight: number;
}>`
  background: url(${props => cloudAssetUrl(props.backgroundImage, { mobileResizeWidth: 800, optimization: 'mild' })});
  background-repeat: no-repeat;
  background-position: center bottom;
  background-size: cover;
  position: relative;
  height: 1540px;
  ${themeMediaQuery('below_sm')} {
    width: 100%;
    background-size: 190%;
    padding-bottom: 0%;
    background-position: bottom;
    height: ${({ resHeight }) => resHeight}px;
  }
  ${themeMediaQuery('xl')} {
    height: 1850px;
    margin-top: -50px;
  }
`;

export const StyledImagesRow = styled(Flex)`
  position: absolute;
  justify-content: space-between;
  width: 100%;
  top: 0px;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  .text-pairing-title {
    max-width: 450px;
  }
  .text-pairing-body {
    width: 410px;
    max-width: 410px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-body {
      width: auto;
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 480px;
    }
    .text-pairing-body {
      width: auto;
      max-width: 500px;
    }
  }
`;

export const StateIconWrapper = styled(Flex)`
  justify-content: space-between;
  width: calc(100vw / 1.1);
  max-width: 600px;
  ${themeMediaQuery('below_sm')} {
    max-width: 100%;
    width: 100%;
    padding-left: 2.5rem;
    padding-right: 2.5rem;
    display: grid;
    grid-template-columns: 50% 50%;
  }
`;

export const StateIconTextContainer = styled(Flex)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${themeMediaQuery('below_sm')} {
    /* width: 50%; */
    margin-bottom: 30px;
  }
`;

export const StateIcon = styled(Flex)`
  width: 64px;
  height: 64px;
  background-color: rgba(117, 156, 255, 0.1);
  border-radius: 50%;
  margin-bottom: 10px;
  justify-content: center;
  align-items: center;
  ${themeMediaQuery('below_sm')} {
    width: 70px;
    height: 70px;
  }
`;

export const IconTextPairing = styled(TextPairing)`
  .text-pairing-title {
    ${themeMediaQuery('below_sm')} {
      font-size: 14px;
    }
  }
`;

export const HeroTextContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  padding-top: ${themeSpace(10)};
  ${themeMediaQuery('below_sm')} {
    padding-top: ${themeSpace(0)};
  }
`;

export const StyledHeroTextColumn = styled(Columns)`
  ${themeMediaQuery('sm')} {
    max-width: 55rem;
  }
  ${themeMediaQuery('lg')} {
    max-width: 90rem;
  }
`;
